import { DisciplineSchedule } from '../../Components/DisciplineSchedule';

export const CmpHighpowerSchedule = () => {
  return (
    <DisciplineSchedule 
      discipline="CMP_HIGHPOWER" 
      disciplineName="CMP Highpower/Service Rifle"
    />
  );
};
